export type Nullable<T> = T | null;
export type ProvinceType = 'QC' | 'ON' | 'MB' | 'SK' | 'AB' | 'BC' | 'PE' | 'NB' | 'NL' | 'NS' | 'YT' | 'NT' | 'NU';

export interface UpdateEmailInfo {
	currentPassword: string;
	email: string;
}

export interface EmailEditForm {
	currentPassword: string;
	email: string;
	code?: string;
}

export interface LayoutScreenInfo {
	desktop: boolean;
	mobile: boolean;
	tablet: boolean;
}

export const Province = {
	QC: 'Québec' as ProvinceType,
	ON: 'Ontario' as ProvinceType,
	MB: 'Manitoba' as ProvinceType,
	SK: 'Saskatchewan' as ProvinceType,
	AB: 'Alberta' as ProvinceType,
	BC: 'Colombie-Britanique' as ProvinceType,
	PE: 'Île-du-Prince-Édouard' as ProvinceType,
	NB: 'Nouveau-Brunswick' as ProvinceType,
	NL: 'Terre-Neuve-et-Labrador' as ProvinceType,
	NS: 'Nouvelle-Écosse' as ProvinceType,
	YT: 'Yukon' as ProvinceType,
	NT: 'Territoires du Nord-Ouest' as ProvinceType,
	NU: 'Nunavut' as ProvinceType
};

export interface AccessCodeInfo {
	companyCode: string;
	companyName: string;
	endAt?: Date;
	firstName: string;
	groupCode: string;
	id: string;
	lastName: string;
	organizationCode: string;
	single: boolean;
	startAt?: Date;
	used: boolean;
	userCode: string;
	values?: any;
}

export interface AccessCodeSearchInfo {
	companyCode: string;
	organization?: OrganizationInfo;
	userCode: string;
}

export type AccessCodeInitType = 'add' | 'delete' | 'list';

export interface ParkResponse {
	city: string;
	civicNumber1: string;
	civicNumber2: string;
	email: string;
	gpsLatitude: number;
	gpsLongitude: number;
	parkIdentificationNo: number;
	parkName: string;
	phoneExtension: string;
	phoneNo: string;
	postalCode: string;
	province: ProvinceType;
	serverHostName: string;
}

export interface FaqDataInfo {
	groups: FaqGroupInfo[];
	list: FaqInfo[];
}

export interface FaqInfo {
	body: string;
	collapse: boolean;
	group?: string;
	id: string;
	order: number;
	organization?: string;
	title: string;
	visible: boolean;
}

export interface FaqGroupInfo {
	collapse: boolean;
	id: string;
	name: string;
	order: number;
	organization?: string;
	title: string;
	visible: boolean;
}

export interface NodeItem {
	children?: {
		[k: string]: NodeItem | null;
	};
	class?: string;
	enabled: boolean;
	icon: string;
	id: string;
	link: string;
	priority?: number;
	title: string;
	type: 'group' | 'item';
}

export interface NodeSidebar {
	[K: string]: NodeItem;
}

export interface ProfileWritableEntities {
	displayName: string;
	photoURL: string;
}

export interface ProfileEditForm {
	displayName: string;
	photoURL: string;
}

export interface ProfileInfo extends ProfileWritableEntities {
	createdAt: string;
	displayName: string;
	email: string;
	emailVerified: boolean;
	isAnonymous: boolean;
	lastLoginAt: string;
	phoneNumber: string;
	photoURL: string;
	uid: string;
}

export interface RegisterEmailForm {
	cip?: string;
	confirmPassword: string;
	email: string;
	method: string;
	password: string;
}

export interface User {
	createdAt: string;
	displayName: string;
	email: string;
	emailVerified: boolean;
	isAnonymous: boolean;
	lastLoginAt: string;
	phoneNumber: string;
	photoURL: string;
	uid: string;
}

export interface SessionClaims {
	accessLevel: number;
	admin: boolean;
}

export interface Session {
	claims: SessionClaims;
	createdAt: string;
	displayName: string;
	email: string;
	emailVerified: boolean;
	isAnonymous: boolean;
	isLoaded: boolean;
	lastLoginAt: string;
	phoneNumber: string;
	photoURL: string;
	uid: string;
}

export interface CodeForm {
	companyCode: string;
	userCode: string;
}

export interface ContractForm {
	contractNo: string;
	phone?: string;
	postalCode: string;
	matricule?: string;
	method: 'contract' | 'matricule';
	firstName?: string;
	lastName?: string;
}

export type SectorType = 'Tgps' | 'Horodateur' | 'Vignette' | 'Autre';

export interface SectorInfo {
	isActive: boolean;
	parkIdentificationNo: number;
	sectorDescription: string;
	sectorId: number;
	sectorName: string;
	sectorType: SectorType;
}

export interface UserEntity {
	user: User;
}

export interface AuthCodeInfo {
	apiKey?: string;
	continueUrl?: string;
	lang?: string;
	mode: string;
	oobCode: string;
}

export interface MetadataState {
	refreshUser: string;
}

export interface ActionCodeInfo {
	apiKey?: string;
	continueUrl?: string;
	lang?: string;
	mode: string;
	oobCode: string;
}

export interface ResetPasswordInfo {
	confirmPassword: string;
	currentPassword: string;
	password: string;
}

export interface UpdatePasswordForm {
	confirmPassword: string;
	currentPassword: string;
	password: string;
	code?: string;
}

export interface ForgotPasswordForm {
	email: string;
}

export interface ResetPasswordForm {
	code?: string;
	confirmPassword: string;
	password: string;
}

export interface LoginForm {
	email: string;
	password: string;
	code?: string;
}

export type Entity<K extends string, T> = {
	[P in K]: T;
};

export interface AuthCredential {
	providerId: string;
	signInMethod: string;
}

export interface Vehicule {
	description: string;
	id: number;
	key: string;
	licencePlate: string;
	manufacturer: string;
	model: string;
	vehiculeYear: string;
}

export enum Manufacturer {
	NotDefined = 'Autre',
	Saturn = 'Saturn',
	Nissan = 'Nissan',
	FordMercury = 'Ford | Mercury',
	JeepChrysler = 'Jeep | Chrysler',
	Toyota = 'Toyota',
	Mazda = 'Mazda',
	Hyundai = 'Hyundai',
	Suzuki = 'Suzuki',
	GmChevroletPontiac = 'Gm | Chevrolet | Pontiac',
	Kia = 'Kia',
	HondaAcura = 'Honda | Acura',
	MercedesBmw = 'Mercedes | Bmw',
	Dodge = 'Dodge',
	Subaru = 'Subaru',
	Tesla = 'Tesla'
}

export interface VehicleInfo {
	description: string;
	id: number;
	licencePlate: string;
	manufacturer: string;
	model: string;
	vehiculeYear: number;
}

export interface PaymentMethodInfo {
	creditCardDataKey: string;
	effectiveDate: string;
	endDate: string;
	financialInstitutionId: number;
	folioNo: string;
	method: 'Cash' | 'PreAuthorized' | 'Credit' | 'DAS' | 'DeductionAtSource' | 'NotDefined' | 'CreditLumpSum';
	transitNo: string;
}

export enum DocumentType {
	SpaqCard = '',
	Transponder = '',
	PermantlyLabel = '',
	MonthlyLabel = '',
	CapitalCard = '',
	OwnerCard = '',
	SpaqBikeCard = ''
}

export enum DocumentState {
	InCirculation = '',
	Available = '',
	Lost = '',
	Broken = '',
	Nap = ''
}

export interface AccesDocumentInfo {
	documentNo?: string;
	documentState?: DocumentState;
	documentType?: DocumentType;
}

export interface SubscriptionInfo {
	custom: any;
	spaq: SubscriptionSpaqInfo;
}

export interface SubscriptionSpaqInfo {
	accesDocuments?: AccesDocumentInfo[];
	accessOnHoldReason: string;
	addressLine1: string;
	addressLine2: string;
	appartmentNo: string;
	balance: number;
	cellPhone: string;
	city: string;
	contractNo: number;
	dynamicFieldJsonData: string;
	email: string;
	firstName: string;
	homePhone: string;
	homePhoneExtension: string;
	identificationCode: string;
	isAccessOnHold: boolean;
	language: LanguageType;
	lastName: string;
	paymentMethod: PaymentMethodInfo;
	postalCode: string;
	province: ProvinceType;
	serviceCenter: number;
	sex: SexType;
	workPhone: string;
	workPhoneExtension: number;
}

export type LanguageType = 'French' | 'English';

export const Language = {
	French: 'French' as LanguageType,
	English: 'English' as LanguageType
};

export type SexType = 'Female' | 'Male' | 'Unknown';

export const Sex = {
	Female: 'Female' as SexType,
	Male: 'Male' as SexType,
	Unknown: 'Unknown' as SexType
};

export interface AccountStatusState {
	isAccessCodeRequired: boolean;
	isCipRequired: boolean;
	isCompleted: boolean;
	isContractRequired: boolean;
	isSubscriptionRequired: boolean;
}

export interface UserAccountStatus {
	isAccessCodeRequired: boolean;
	isCipRequired: boolean;
	isCompleted: boolean;
	isContractRequired: boolean;
	isSubscriptionRequired: boolean;
}

export type PartialMonthCalculation = 'NotDefined' | 'Ratio' | 'MiddleMonth';
export type ServiceBillingType = 'Monthly' | 'PerUse' | 'AtBooking' | 'Decremental' | 'Maintenance' | 'LumpSum' | 'DAS' | 'Episodic';
export type ServiceStartRule =
	| 'NotDefined'
	| 'FirstDayOfNextMonth'
	| 'FirstDayOfCurrentMonth'
	| 'SubscriptionDay'
	| 'FirstDayOfFlatRateDuration';
export type PublicType = 'Public' | 'PublicWithApprobation';
export type PrivateType = 'Private' | 'PrivateWithApprobation';
export type ServiceType = PublicType | PrivateType;
export type TimeUnit = 'Minute' | 'Hour' | 'Day' | 'Week' | 'Month' | 'Counter';

export interface ServiceInfo {
	availableFrom: string;
	availableServiceId?: number;
	availableUntil: string;
	cancelationNotice?: number;
	cancelationNoticeTimeUnit?: TimeUnit;
	duration?: number;
	durationTimeUnit?: TimeUnit;
	isBankingCardPaymentAccepted?: boolean;
	isCancelable?: boolean;
	isCancelationFirstDayOfMonth?: boolean;
	isDasPaymentAccepted?: boolean;
	isFinancialInstitutionPaymentAccepted?: boolean;
	isFixedDuration?: boolean;
	isPpaPaymentAccepted?: boolean;
	isSubscriptionAvailable: boolean;
	isTax1Exempted?: boolean;
	isTax2Exempted?: boolean;
	isTax3Exempted?: boolean;
	meta?: ServiceMetaInfo;
	priceListingInfo: any[];
	onSaleFrom: string;
	onSaleUntil: string;
	parkIdentificationNo: number;
	partialMonthCalculation?: PartialMonthCalculation;
	period: any;
	price?: number;
	sectorId: number;
	serviceBillingType?: ServiceBillingType;
	serviceDescription?: string;
	serviceStartRule?: ServiceStartRule;
	serviceType?: ServiceType;
	webEffectiveDate?: string;
	webEffectiveHour?: string;
	webEndDate?: string;
	webEndHour?: string;
}
export interface ServiceInfoWithGroup {
	service: ServiceInfo;
	groupId: string;
	sectorId: string;
	scopeId: string;
}
export interface UserState {
	accountStatus: UserAccountStatus;
	payments: PaymentInfo[];
	services: SubscriptionService[];
	subscription: SubscriptionInfo;
	subscriptionServices: SubscriptionService[];
	vehicles: Vehicule[];
}

export interface UserVehiclesState {
	collection: Vehicule[];
	hasError: boolean;
	hasSuccess: boolean;
	isLoading: boolean;
	message: any;
	selectedVehicle: Vehicule;
}

export interface UserVehiclesDetailsState {
	hasError: boolean;
	hasSuccess: boolean;
	isLoading: boolean;
	message: any;
}

export interface SubscriptionService {
	effectiveDate: string;
	endDate: string;
	id: number;
	invoiceAmount?: string;
	invoiceFrom?: string;
	invoiceTo?: string;
	isApproved: boolean;
	isCancellationRequest: boolean;
	isPaidByGroup: boolean;
	serviceDescription: string;
	serviceId: number;
}

export interface SubscriptionServiceInfo {
	cancellationDateRequest: string;
	effectiveDate: string;
	endDate: string;
	id: number;
	isApproved: boolean;
	isCancellationRequest: boolean;
	isPaidByGroup: boolean;
	serviceDescription: string;
	serviceId: number;
}

export interface PaymentInfo {
	amount: number;
	contractNo: number;
	financialInstitution: string;
	id: number;
	invoicePayments: InvoicePaymentInfo[];
	noReference: string;
	paymentMethodDescription: string;
	processDate: string;
}

export interface InvoicePaymentInfo {
	invoiceAmount: number;
	invoiceDate: string;
	invoiceDescription: string;
	invoiceId: number;
	invoiceTax1: number;
	invoiceTax2: number;
	invoiceTotalAmount: number;
	paidAmount: number;
}

export interface PaymentEntity {
	force: boolean;
	text: string;
	value: string;
}

export interface PaymentPPAInfo {
	downloadUrl: string;
	effectiveDate: string;
	financialInstitutionId: number;
	folioNo: number;
	institutionName: string;
	transitNo: number;
}

export interface CCInfo {
	cardNumber: string;
	cvd: string;
	expireMonth: string;
	expireYear: string;
}

export interface ResAddCc {
	avsStreetName: string;
	avsStreetNumber: string;
	avsZipcode: string;
	cryptType: string;
	custId: string;
	dataKeyFormat: string;
	email: string;
	expdate: string;
	note: string;
	pan: string;
	phone: string;
}

export interface ParkInfo {
	city: string;
	civicNumber1: string;
	civicNumber2: string;
	email: string;
	gpsLatitude: number;
	gpsLongitude: number;
	parkIdentificationNo: number;
	parkName: string;
	phoneExtension: string;
	phoneNo: string;
	postalCode: string;
	province: ProvinceType;
	serverHostName: string;
}

export interface ContractCostInfo {
	invoiceAmount: number;
	invoiceDate: string;
	invoiceDescription: string;
	invoiceId: number;
	invoiceTax1: number;
	invoiceTax2: number;
	invoiceTotalAmount: number;
	paidAmount: number;
}

export interface ContractInfo {
	approve: boolean;
	conditionsPaymentAcceptedAt: string;
	conditionsServiceAcceptedAt: string;
	cost: ContractCostInfo;
	createdAt: string;
	isCreationCompleted: boolean;
	isPaid: boolean;
	isPaymentCompleted: boolean;
	enableWaitingList: boolean;
	groupId: string;
	sectorId: string;
	scopeId: string;
	park: ParkInfo;
	payment: 'Cash' | 'PreAuthorized' | 'Credit' | 'DAS' | 'DeductionAtSource' | 'NotDefined' | 'CreditLumpSum';
	paymentBeforeApproval: boolean;
	pdfContent: string;
	pdfLink: string;
	pdfSuccess: boolean;
	service: ServiceInfo;
	services: ServiceInfo[];
	subscription: SubscriptionInfo;
	subscriptionService: SubscriptionService;
	subscriptionServices: SubscriptionService[];
	vehicles: Vehicule[];
}

export interface AccessCodeMetasConditions {
	paymentCc: string;
	paymentDas: string;
	paymentInternet: string;
	paymentPpa: string;
	service: string;
}

export interface AccessCodeServiceCustomFieldsValue {
	key: string;
	value: string;
}

export interface AccessCodeServiceCustomFields {
	groupCode: string;
	label: string;
	name: string;
	order: number;
	organizationCode: string;
	required: boolean;
	type: 'text' | 'textarea' | 'combobox';
	values: AccessCodeServiceCustomFieldsValue[];
}

export interface AccessCodeMetasInfo {
	conditions: AccessCodeMetasConditions;
	customFields: AccessCodeServiceCustomFields[];
}

export interface AccessCodeGroupInfo {
	groupCode: string;
	groupDescription: string;
	meta: AccessCodeMetasInfo;
	organizationCode?: string;
	public: boolean;
	services?: AccessCodeServiceInfo[];
}

export interface AccessCodeServiceInfo {
	groupCode?: string;
	organizationCode?: string;
	parkIdentificationNo: number;
	serviceEntity?: ServiceInfo;
	serviceId: number;
}

export interface OrganizationConfigInfo {
	disablePublicSubscriptionService: boolean;
	enableGateway: boolean;
	enablePrivateRegistration: boolean;
	enablePublicRegistration: boolean;
}

export interface OrganizationInfo {
	adresse: string;
	city: string;
	config?: OrganizationConfigInfo;
	groups?: AccessCodeGroupInfo[];
	logo?: string;
	organizationCode: string;
	organizationName: string;
	phoneNumber: string;
	postalCode: string;
	province: string;
}

export interface TestGroupInfo {
	id: string;
	name: string;
	tests?: TestInfo[];
}

export interface TestInfo {
	groupId: string;
	id: number;
	level: 'simple' | 'medium' | 'hard';
	name: string;
	timestamp: number;
	when: string;
}

export interface ContractSearchForm {
	contractNo: string;
	phone?: string;
	postalCode: string;
	matricule?: string;
	method: 'contract' | 'matricule';
	firstName?: string;
	lastName?: string;
}

export interface ServiceMetaInfo {
	note: string;
}

export interface MonerisConfigurationKey {
	id: string;
	key: string;
}

export interface MonerisConfiguration {
	paypage: MonerisConfigurationKey;
	url: string;
	vault: MonerisConfigurationKey;
}

export interface SystemConfiguration {
	moneris: MonerisConfiguration;
}
